import { MessageSquare, Users, TrendingUp } from 'lucide-react'

interface CommunityProps {
  user: any
}

export default function Community({ user }: CommunityProps) {
  return (
    <div className="min-h-screen bg-neutral-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="font-heading font-bold text-section text-neutral-800 mb-8">
          Comunidad
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <div className="bg-white rounded-lg shadow-md p-6 mb-6">
              <h2 className="font-semibold text-lg mb-4">Foros de Discusión</h2>
              <div className="space-y-4">
                <div className="border border-neutral-200 rounded-lg p-4 hover:bg-neutral-50 cursor-pointer">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="font-medium">Política Local y Presupuestos</h3>
                    <span className="text-sm text-neutral-600">45 mensajes</span>
                  </div>
                  <p className="text-sm text-neutral-600">
                    Discute estrategias para influir en decisiones municipales
                  </p>
                </div>

                <div className="border border-neutral-200 rounded-lg p-4 hover:bg-neutral-50 cursor-pointer">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="font-medium">Cambio Climático: Acción Local</h3>
                    <span className="text-sm text-neutral-600">128 mensajes</span>
                  </div>
                  <p className="text-sm text-neutral-600">
                    Comparte iniciativas climáticas en tu comunidad
                  </p>
                </div>

                <div className="border border-neutral-200 rounded-lg p-4 hover:bg-neutral-50 cursor-pointer">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="font-medium">Justicia Social y Racismo</h3>
                    <span className="text-sm text-neutral-600">89 mensajes</span>
                  </div>
                  <p className="text-sm text-neutral-600">
                    Debate sobre estructuras de desigualdad y soluciones
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="bg-white rounded-lg shadow-md p-6 mb-6">
              <h2 className="font-semibold text-lg mb-4 flex items-center space-x-2">
                <TrendingUp className="w-5 h-5 text-community" />
                <span>Trending</span>
              </h2>
              <div className="space-y-2">
                <div className="text-sm">
                  <span className="text-action">#PresupuestoParticipativo</span>
                  <p className="text-xs text-neutral-600">234 menciones</p>
                </div>
                <div className="text-sm">
                  <span className="text-action">#EducacionPublica</span>
                  <p className="text-xs text-neutral-600">189 menciones</p>
                </div>
                <div className="text-sm">
                  <span className="text-action">#AccionClimatica</span>
                  <p className="text-xs text-neutral-600">156 menciones</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6">
              <h2 className="font-semibold text-lg mb-4 flex items-center space-x-2">
                <Users className="w-5 h-5 text-community" />
                <span>Top Contributors</span>
              </h2>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-education rounded-full flex items-center justify-center text-white font-bold">
                    M
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-medium">María R.</p>
                    <p className="text-xs text-neutral-600">850 puntos</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-action rounded-full flex items-center justify-center text-white font-bold">
                    J
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-medium">Javier L.</p>
                    <p className="text-xs text-neutral-600">720 puntos</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-community rounded-full flex items-center justify-center text-white font-bold">
                    A
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-medium">Ana S.</p>
                    <p className="text-xs text-neutral-600">680 puntos</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
